import {IShellEvent} from './IShellEvent';
import {NavigationInfo, ShellCommunicationEvents} from '@shared/generalInterfaces';
import {Injectable} from '@angular/core';
import { ApplicationNavigationService } from 'app/services/shell/application-navigation/application-navigation.service';

@Injectable({providedIn: 'root'})
export class PushNavigationStateEvent implements IShellEvent {
	readonly domain = window.location.origin;
	constructor(private applicationNavigationService: ApplicationNavigationService) { }

	get eventName(): string {
		return ShellCommunicationEvents.PushNavigationState;
	}

	async handleCustomEvent(event: any) {
		let navigationUrl: string;
		try {
			const url = new URL(event.data.urlFrom);
			navigationUrl = url.pathname + url.search
		} catch (error) {
			navigationUrl = event.data.urlFrom;
		}

		let transition = {
            navigatedFromAppId: event.data.navigatedFromAppId,
            urlFrom: navigationUrl,
            navigatedToAppId: event.data.navigatedToAppId
        } as NavigationInfo;
        this.applicationNavigationService.pushTransition(transition);
	}

	handlePostMessage(event): void {}
}
